import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {UserSubscription} from "../../../../../../user/user-subscription";
import {OneMonthFreeStep} from "../../one-month-free.component";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";

interface IFeature {
  title: string;
  header: boolean;
}

@Component({
    selector: 'db-one-month-free-ecommerce',
    templateUrl: './one-month-free-ecommerce.component.html',
    styleUrls: ['./one-month-free-ecommerce.component.scss'],
    standalone: false
})
export class OneMonthFreeEcommerceComponent implements OnInit {

  @Input() currentSubscription: UserSubscription;
  @Output() onStepChange = new EventEmitter<OneMonthFreeStep>();
  public isMobile: boolean;
  public scrolled: boolean;
  public features: IFeature[];

  constructor(
    private el: ElementRef,
    private readonly activeModal: DbActiveModal,
  ) { }

  ngOnInit() {
    this.activeModal.whiteCloseBtn(true, 0.5);
    this.isMobile = window.innerWidth <= 991;
    this._setFeatures();

    const elements = document.getElementsByClassName("ecommerce");
    if (elements.length > 0) {
      const el = elements[0];
      el.addEventListener("scroll", () => {
        this.scrolled = el.scrollTop > 5;
      });
    }

  }

  private _setFeatures(): void {
    this.features = [
      {
        title: 'Personalize your store',
        header: true
      },
      {
        title: 'Customize your store with a no-code AI drag and drop editor',
        header: false
      },
      {
        title: 'Connect a free custom domain',
        header: false
      },
      {
        title: 'Use a built-in design system to craft your brand',
        header: false
      },
      {
        title: 'Add unlimited products',
        header: true
      },
      {
        title: 'Generate product descriptions and images with AI',
        header: false
      },
      {
        title: 'Manage your inventory',
        header: false
      },
      {
        title: 'Create product variations',
        header: false
      },
      {
        title: 'Start selling',
        header: true
      },
      {
        title: 'Activate 10Web Payments',
        header: false
      },
      {
        title: 'Grow your sales with the conversion-optimized checkout',
        header: false
      },
      {
        title: 'Track your sales, taxes, and refunds',
        header: false
      },
      {
        title: 'Optimized website speed for higher conversions',
        header: false
      },
    ];
  }

}

